import { Component, Prop, Watch, Vue } from 'vue-property-decorator';

import { CurrencyInfo } from '@/core/currency/interfaces';
import { formatCurrency } from '@/core/currency/helpers';
import { LoyaltyInfo } from '@/core/payment-card/interfaces';

@Component({
    data() {
        return {
            sliderValue: null
        };
    }
})
export default class LoyaltySlider extends Vue {
    @Prop(Number)
    value: number

    @Prop(Object)
    currency: CurrencyInfo;

    @Prop(Object)
    loyaltyInfo: LoyaltyInfo;

    @Prop(Number)
    precision: number;

    sliderValue: number;

    mounted() {
        this.sliderValue = this.max;
    }

    @Watch('sliderValue')
    onChangeSliderValue(value) {
        this.$emit('input', this.adjustSliderValue(value));
    }

    get max() {
        const addition
            = (Math.ceil(this.loyaltyInfo.maxRedemptionAmount / 100) - (this.loyaltyInfo.maxRedemptionAmount / 100));

        return this.loyaltyInfo.maxRedemptionAmount + (addition * 100);
    }

    get min() {
        return this.loyaltyInfo.minRedemptionAmount !== this.loyaltyInfo.maxRedemptionAmount
            ? this.loyaltyInfo.minRedemptionAmount
            : 0;
    }

    get step() {
        return this.loyaltyInfo.redemptionAmountStep * this.precision;
    }

    adjustSliderValue(value) {
        if (value > this.loyaltyInfo.maxRedemptionAmount) {
            return this.loyaltyInfo.maxRedemptionAmount;
        }

        return value;
    }

    format(value: number, format: string) {
        return formatCurrency(
            value || '0',
            this.currency?.format,
            format
        );
    }
}
